export const bestReview = [
  {
    id: 1,
    image:
      'https://firebasestorage.googleapis.com/v0/b/mongsom-22c9b.firebasestorage.app/o/review%2F%E1%84%85%E1%85%B5%E1%84%87%E1%85%B2_%E1%84%92%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%B71.jpg?alt=media&token=346ac8b7-22fe-463c-8be9-1e76e3a99d46',
    title: '핸드크림 선물세트',
    description: '결혼식 답례품',
    review:
      '결혼식 답례품으로 핸드크림 선물세트를 준비했는데, 하객들 반응이 정말 좋았습니다!여성분들은 상큼하고 산뜻해서 시트러스 향을 더 좋아하셨고, 코코넛은 남자분들에게 특히 인기가 있었어요~! 실용적이면서도 분위기 있는 답례품을 찾는 분들께 정말 추천하고 싶은 구성입니다!',
  },
  {
    id: 2,
    image:
      'https://firebasestorage.googleapis.com/v0/b/mongsom-22c9b.firebasestorage.app/o/review%2F%E1%84%85%E1%85%B5%E1%84%87%E1%85%B2_%E1%84%92%E1%85%A2%E1%86%AB%E1%84%83%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%B72.jpg?alt=media&token=feda1e90-88ae-494f-8a79-f81c35813813',
    title: '핸드크림',
    description: '생일선물',
    review:
      '친구 생일선물을 고르다가 우연히 이 핸드크림을 보게 됐는데, 패키지가 너무 귀여워서 “선물용으로 딱이다!" 싶어 바로 구매했어요~ 친구가 향이 너무 좋다길래 결국 저도 쓰려고 재구매했습니다 ㅎㅎ 향은 말할 것도 없고 발랐을 때 끈적임 없이 잘 흡수되고 보습력 또한 너무 좋아서 사계절 내내 잘 쓸 수 있을 거 같아요~!',
  },
  {
    id: 3,
    image:
      'https://firebasestorage.googleapis.com/v0/b/mongsom-22c9b.firebasestorage.app/o/review%2F%E1%84%85%E1%85%B5%E1%84%87%E1%85%B2_%E1%84%92%E1%85%A2%E1%86%BC%E1%84%8C%E1%85%AE1.jpg?alt=media&token=279ffd6d-e4df-41d6-9c6f-3e37f5f56b9a',

    title: '다회용 행주',
    description: '개인 구매',
    review:
      '다회용 행주라고 해서 주방에서만 쓰는 줄 알았는데, 막상 받아보니 집 안 어디에 둬도 예쁜 오브제 같은 느낌이더라구요. 사진처럼 화분 아래에 깔아두면 깔끔하고 정돈된 분위기가 딱 잡혀요. 제일 마음에 드는 건 내구성이에요! 여러 번 빨고 사용해도 쉽게 해지지 않고 형태가 잘 유지돼요. 일반 일회용 행주랑은 비교가 안 되게 오래가서 훨씬 경제적이에요!',
  },
  {
    id: 4,
    image:
      'https://firebasestorage.googleapis.com/v0/b/mongsom-22c9b.firebasestorage.app/o/review%2F%E1%84%85%E1%85%B5%E1%84%87%E1%85%B2_%E1%84%92%E1%85%A2%E1%86%BC%E1%84%8C%E1%85%AE2.jpg?alt=media&token=8d5992ba-5dc4-4450-a301-a1c09e1e32e4',

    title: '다회용 행주',
    description: '개인 구매',
    review:
      '주방에서 가장 만족도 높은 아이템이 됐습니다. 사진처럼 롤 형태라서 필요할 때마다 한 장씩 바로 뜯어 쓰기 편해요. 힘 없이 흐물거리는 느낌이 아니라 탄탄해서 설거지 후 물기 닦을 때, 조리대 정리할 때, 냄비 받침용으로도 문제없이 사용할 수 있어용',
  },
];
